<script>
/* global axios */
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';

export default {
  name: 'SelectActiveBranchModal',
  computed: {
    ...mapGetters('stripe', ['getAppointmentBranchesLimit']),
    ...mapGetters('appointments', ['branchList']),
    ...mapGetters(['getCurrentAccountId']),
    proxyBase() { return `/api/v1/accounts/${this.getCurrentAccountId}/proxy/knowledge`; },
  },
  data() {
    return { selectedBranchIds: [] };
  },
  methods: {
    async updateActiveBranches() {
      try {
        const { data: response } = await axios.post(
          `${this.proxyBase}/subscription/${this.getCurrentAccountId}/active_branches`,
          { ids: this.selectedBranchIds }
        );
        useAlert(this.$t('BRANCHES.SELECT_ACTIVE_BRANCH_MODAL.SUCCESS_UPDATE'));
        this.$emit('close');
      } catch (err) {
        console.error(err);
        useAlert(err);
      }
    },
  },
};
</script>

<template>
  <div
    class="fixed inset-0 bg-slate-800/50 dark:bg-white/50 flex items-center justify-center px-4 z-50"
  >
    <div class="p-6 border-2 rounded-lg bg-white dark:bg-slate-800 shadow-xl max-w-sm w-full">
      <h1 class="mb-4">
        {{ $t('BRANCHES.SELECT_ACTIVE_BRANCH_MODAL.TITLE') }}
        <span class="text-red-500">{{ getAppointmentBranchesLimit }}</span>
        {{ $t('BRANCHES.SELECT_ACTIVE_BRANCH_MODAL.SUBTITLE') }}
      </h1>
      <div
        class="grid grid-flow-rows auto-rows-5 gap-4 my-4 max-h-[400px] overflow-auto bg-slate-100 rounded-sm"
      >
        <label
          v-for="branch in branchList.results"
          :key="branch.branch_id"
          class="flex justify-between items-center p-4 rounded-md [has(input:disabled)]:bg-slate-100/50 [has(input:disabled)]:dark:bg-slate-500/50"
          :class="{
            'bg-slate-100 hover:bg-slate-200 dark:bg-slate-500 hover:dark:bg-slate-600 cursor-pointer':
              selectedBranchIds.length < getAppointmentBranchesLimit ||
              selectedBranchIds.includes(branch.branch_id),
            'opacity-50 cursor-not-allowed':
              selectedBranchIds.length >= getAppointmentBranchesLimit &&
              !selectedBranchIds.includes(branch.branch_id),
          }"
        >
          <!-- TODO: i18n -->
          {{ branch.branch_name }}
          <input
            type="checkbox"
            v-model="selectedBranchIds"
            :value="branch.branch_id"
            class="h-5 w-5 rounded-md border-2 cursor-pointer shadow-inner disabled:cursor-not-allowed disabled:bg-slate-100/50 dark:disabled:bg-slate-500/50"
            :disabled="
              selectedBranchIds.length >= getAppointmentBranchesLimit &&
              !selectedBranchIds.includes(branch.branch_id)
            "
          />
        </label>
      </div>
      <div class="flex justify-end">
        <woot-button
          variant="smooth"
          :disabled="selectedBranchIds.length == 0"
          @click="updateActiveBranches"
        >
          {{ $t('BRANCHES.SELECT_ACTIVE_BRANCH_MODAL.CONFIRM') }}
        </woot-button>
      </div>
    </div>
  </div>
</template>
